import React, { Fragment } from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import Pipe from '../Pipe';

const buttonStyles = { textTransform: 'none', letterSpacing: 'normal' };

const ButtonLink = ({ handleClick, text, withPipe }) => (
  <Fragment>
    <Button
      style={buttonStyles}
      bsPrefix="btn btn-xs btn-link"
      onClick={handleClick}
    >
      {text}
    </Button>
    {withPipe && <Pipe />}
  </Fragment>
);

ButtonLink.propTypes = {
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  withPipe: PropTypes.bool
};

export default ButtonLink;
